// Shipping region codes
export const EVERYWHERE_CODE = 'XX';
export const US_CON = 'US_CON';
export const US_AK = 'US_AK';
export const US_HI = 'US_HI';
export const US_PR = 'US_PR';
export const US_OTHER = 'US_OTHER';

export const AFFIRM_SUPPORTED_SHIPPING_REGIONS = [
  EVERYWHERE_CODE,
  US_CON,
  US_AK,
  US_HI,
  US_PR,
  US_OTHER,
];

// Country codes
export const US = 'US';
export const UK = 'GB';

// Supported locales
export const DE = 'de';
export const EN = 'en';
export const ES = 'es';
export const FR = 'fr';
export const IT = 'it';
export const JA = 'ja';

export const NUMBER_OR_FLOAT_KEYS_REGEX = /\d|\.|\,|\s/;

export const CORE_DEFAULT_OG_IMAGE_URL =
  'https://static.reverb-assets.com/assets/homepage/open-graph-2a0cbbc49a26d873db03aae487defc6d.jpg';

export const LP_NATIVE = 'lp_native';
export const IOS = 'ios-app';
export const ANDROID = 'android-app';
export const MOBILE_PHONE = 'mobile-browser';
export const TABLET = 'tablet-browser';
export const WEB = 'web';
export const DEALS_AND_STEALS_CURATED_SET_ID = '8';
export const DEALS_AND_STEALS_CMS_PAGE_SLUG = 'deals-and-steals';

export enum CmsPageType {
  BUYING_GUIDE = 'buying_guide',
  CATEGORY = 'category',
  EMBED = 'embed',
  FEATURED = 'featured',
  GEAR = 'gear',
  LEGAL = 'legal',
  MOBILE = 'mobile',
  PRESS = 'press',
  PROMO = 'promo',
  ROOT = 'root',
  SALE = 'sale',
  SELLING = 'selling',
  SEO_LANDING_PAGE = 'seo_landing_page',
}

export enum ExperimentBucketType {
  NULL = '',
  DEFAULT = 'default',
  EXPERIMENT = 'experiment',
}

export const currencies = {
  USD: 'USD',
};

export const GOOGLE_RECAPTCHA_ACTIONS = {
  SIGNUP: 'signup',
};
export const GOOGLE_RECAPTCHA_TOKEN_PARAM = 'google_recaptcha_token';
